<template>
  <div>
    <div
      v-for="(bar, index) in bars"
      :key="index"
      class="mt-1"
    >
      <h4>{{ bar.title }} <small>
        <b-link
          v-if="!inprogress"
          @click="sendPdfs(bar.id)"
        >Send PDF Reports</b-link>
      </small></h4>
      <label v-if="bar.recordCount"><b-spinner
        v-if="bar.id == startPageId && inprogress"
        small
        class="mr-1"
        label="working..."
      />{{ (bar.sentCount + bar.errCount) }} of {{ bar.recordCount }} reports completed (OK:
        {{ bar.sentCount }} ERR: {{ bar.errCount }})</label>
      <b-progress
        height="2rem"
        :max="100"
        class="progress-bar-success"
      >
        <b-progress-bar
          :animated="percent(bar) < 100"
          :value="percent(bar).toFixed(2)"
          :label="`${percent(bar).toFixed(2)}%`"
          :variant="percent(bar) < 100 ? 'warning' : 'success'"
        />
      </b-progress>

    </div>
  </div>
</template>

<script>
import {
  BSpinner, BProgress, BProgressBar, BLink,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import dayjs from 'dayjs'

export default {
  components: {
    BSpinner,
    BLink,
    BProgress,
    BProgressBar,
  },
  data: () => ({
    timer: null,
    bars: [],
    startPageId: 0,
    startTime: null,
    inprogress: false,
  }),
  mounted() {
    this.getList()
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
  },
  created() {
    // this.getData()
  },
  methods: {
    percent(bar) {
      return ((bar.sentCount + bar.errCount) / bar.recordCount) * 100
    },
    sendPdfs(pageId) {
      this.inprogress = true
      this.$swal({
        icon: 'success',
        title: 'In Progress!',
        text: 'PDF generation is in progress...',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })

      this.startPageId = pageId
      this.startTime = dayjs().format('YYYY-MM-DD HH:mm:ss')

      this.timer = setInterval(() => {
        this.getStatus()
      }, 2000)

      // TODO: test run?
      // TODO: send pdfs
      useJwt.axiosIns.get(`page/sendPdfs/${pageId}`)
        .then(response => {
          if (response.data === 'Ok') {
            this.$swal({
              icon: 'success',
              title: 'Completed!',
              text: 'PDF reporting is completed.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          } else {
            this.$swal({
              icon: 'error',
              title: 'Error!',
              text: 'Some error(s) ocurred!',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            })
            clearInterval(this.timer)
            this.timer = null
          }
          clearInterval(this.timer)
          this.timer = null
          this.inprogress = false
        })
        .catch(e => {
          console.log(e)
        })
    },
    variant(value) {
      if (value === 100) {
        return 'success'
      }
      if (value === 0) {
        return 'danger'
      }
      return 'info'
    },
    getList() {
      useJwt.axiosIns.get('page/PdfReportList')
        .then(response => {
          if (response.data) {
            this.bars = response.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    getStatus() {
      useJwt.axiosIns.get(`page/PdfReportStatus/${this.startPageId}/${this.startTime}`)
        .then(response => {
          if (response.data) {
            this.bars.forEach((element, idx) => {
              if (element.id === this.startPageId) {
                this.bars[idx].sentCount = response.data.sentCount
                this.bars[idx].recordCount = response.data.recordCount
              }
            })
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>
